var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 118.772H0V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828L512 118.772z",
    fill: "#ff4b55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 118.781h512v30.495H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M0 149.261h512v30.495H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 179.761h512v30.495H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M512 240.754H8.828A8.829 8.829 0 0 1 0 231.926v-21.667h512v30.495z",
    fill: "#ff4b55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M512 271.248H0v-41.73h8.826l.002 11.236H512z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M0 271.251h512v30.495H0z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 301.741h512v30.495H0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M0 332.241h512v30.495H0z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 362.741h512v30.495H0z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.725H8.828A8.829 8.829 0 0 1 0 414.897V393.23h512v21.667a8.828 8.828 0 0 1-8.828 8.828z",
    fill: "#ff4b55"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.241 240.754H8.828A8.829 8.829 0 0 1 0 231.926V97.104a8.829 8.829 0 0 1 8.828-8.828h132.414a8.829 8.829 0 0 1 8.828 8.828v134.822a8.83 8.83 0 0 1-8.829 8.828z",
    fill: "#41479b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.512 127.738l-8.428 25.27-26.638.206c-2.554.02-3.614 3.279-1.559 4.797l21.429 15.825-8.035 25.398c-.77 2.435 2.003 4.45 4.081 2.965l21.674-15.49 21.672 15.49c2.078 1.485 4.851-.53 4.081-2.965l-8.035-25.398 21.429-15.825c2.055-1.517.995-4.778-1.559-4.797l-26.638-.206-8.428-25.27c-.81-2.424-4.237-2.424-5.046 0z",
    fill: "#f5f5f5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLr);
export default __webpack_public_path__ + "static/media/lr.86782218e2df3c3028418ac06668cc28.svg";
export { ForwardRef as ReactComponent };